<template>
  <div class="account-box js-account-box" @mouseenter="triggerMenu" @mouseleave="triggerMenu">
    <div class="g-account-box">
      <div class="account-info-box">
        <div class="icon"></div>
        <div class="account-info" title="">
          <div class="account-info-name" :title="account.accountName">
            {{ account.companyName }}
          </div>
          <div>
            <span>账户ID:<em>{{ account.customerId }}</em></span>　
            <span>小米ID:<em>{{ account.xiaomiId }}</em></span>
          </div>
        </div>
      </div>
      <ul class="account-menu-list" v-show="showAccountMenu">
        <li v-for="menu in menuList">
          <a :href="menu.url" @click="menuClick(menu)"><i class="iconfont" :class="menu.icon"></i><span>{{ menu.name }}</span></a>
          <ul class="sub-accounts" v-if="menu.children && menu.children.length">
            <li v-for="subMenu in menu.children" :class="{ 'active': subMenu.isCurrent }">
              <a :href="subMenu.url" @click="menuClick(subMenu, true)">
                <div class="subid">
                  子账户　|　ID：{{subMenu.customerId}}
                </div>
                <div class="name">
                  {{subMenu.subAccountName}}
                </div>
                <div class="balance">
                  <div class="num">
                    ￥{{ subMenu.totalBalance }}
                  </div>账户余额：
                </div>
              </a></li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import cookie from 'common/cookie.js';
function _formatBalance(num) {
  return num.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}
export default {
  name: 'account',
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          accounts: [],
          currentUser: {}
        }
      }
    }
  },
  data() {
    return {
      showAccountMenu: false
    };
  },
  computed: {
    account() {
      if (!this.data) return {};
      const { accounts = [], currentUser = {} } = this.data;
      const current = accounts.find(item => item.customerId === currentUser.customerId);
      return {
        accounts: accounts,
        accountName: current.subAccountType === 2 ? current.accountName : '',
        companyName: current.subAccountType === 2 ? current.subAccountName : current.accountName,
        customerId: current.customerId,
        xiaomiId: current.xiaomiId
      }
    },
    menuList() {
      const isAdmin = cookie.getCookie('adSaKey');
      let list = [
        { url: `/v2/dist/tools2.html#!/tools/quality/${this.account.customerId}`, icon: 'icon-11', name: '账户中心' }
      ];
      if (!this.data) return list;
      if (this.account.accounts && this.account.accounts.length > 1) {
        list.push({
          url: 'javascript:;',
          icon: 'icon-46',
          name: '账户切换',
          children: this.account.accounts.map(item => {
            let { subAccountName, totalBalance, customerId, subAccountId, subAccountType } = item;
            let href = window.location.href;
            let url;
            if (!(~href.indexOf('/v2/dist/index.html') || ~href.indexOf('/v2/dist/#/index'))) {
              url = `/v2/dist/index.html#/index/${subAccountId}/${subAccountType}`;
            } else {
              url = `${href.replace(/#.*/, '')}#/index/${subAccountId}/${subAccountType}`;
            }
            return {
              subAccountName,
              totalBalance: _formatBalance(totalBalance),
              customerId,
              isCurrent: this.account.customerId === customerId,
              url
            };
          })
        });
      }
      list.push({
        url: '/account/logout',
        icon: 'icon-10',
        name: '退出'
      });
      if (isAdmin) {
        list.push({
          url: '/superview/entrypage',
          icon: 'icon-8',
          name: '退出超级视图'
        });
      }
      return list;
    }
  },
  methods: {
    triggerMenu() {
      this.showAccountMenu = !this.showAccountMenu;
    },
    menuClick(item, isSub) {
      if (item && (item.url === '/account/logout' || item.url === '/superview/entrypage')) {
        cookie.deleteItem('customerId', '/');
        cookie.deleteItem('customerId');
        sessionStorage.clear();
      }
      if (isSub) {
        let { customerId } = item;
        sessionStorage.setItem('customerId', customerId);
        setTimeout(_ => {
          window.location.reload();
        }, 200);
      }
    }
  }
};
</script>